import * as types from './mutation-types'

export default {
    [types.ADD_ORDER_TO_CART] (state, data) {

    }
}

